import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Tooltip } from "@mui/material"
import {
  getAllSubsDelegationVE,
  updateSubscriptionARCA,
  updateSubsDelegationVE,
} from "../../redux/actions/eventanilla"
import { ConfirmModal } from "../../components/Modals/eventanilla/ConfirmModal"

const VISIBLE_STATUS = [
  "ACTIVE-LOAD-FAIL-NO-AUTH",
  "WAITING-DELEGATION",
  "DELEGATION-MISSING",
  "DELEGATION-CANCEL-IN-PROGRESS",
  "DISABLED",
]
const STATUS_ACCEPTED = "DELEGATION-ACCEPTED"
const REVOKABLE_STATUSES = ["DELEGATION-CANCEL-IN-PROGRESS", "DISABLED"]
const TOOLTIP_MESSAGE =
  "El CUIT al que se la ha aceptado la delegación  NO se encuentra activo en el módulo de e-ventanilla por lo tanto se lo reactivará recién cuando el usuario lo agregue al módulo"
const ACCEPTABLE_STATUS = [
  "ACTIVE-LOAD-FAIL-NO-AUTH",
  "WAITING-DELEGATION",
  "DELEGATION-MISSING",
]
export const AcceptDelegationButton = ({ delegationData }) => {
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState(false)
  // const currentStatus = delegationData?.subscriptionStatus
  const { subscriptionStatus: currentStatus, isRevoked } = delegationData || {
    subscriptionStatus: null,
    isRevoked: false,
  }
  if (!VISIBLE_STATUS.includes(currentStatus)) {
    return null
  }
  const styles = {
    ml: 2,
    width: 180,
    height: 35,
    marginLeft: "6px",
    marginTop: "2px",
    cursor: "pointer",
    borderRadius: "23px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#FFFFFF",
    fontSize: 12,
    fontFamily: "Raleway",
    fontWeight: 700,
    fontStyle: "normal",
    letterSpacing: "0.05em",
    lineHeight: "21px",
    backgroundColor: " #028B7E",
    "&:hover": {
      backgroundColor: "#13796fff",
    },
  }
  const handleOpenModal = () => setOpenModal(true)
  const handleCloseModal = () => setOpenModal(false)

  const handleConfirmAcceptance = async () => {
    if (ACCEPTABLE_STATUS.includes(currentStatus)) {
      await dispatch(
        updateSubscriptionARCA({
          serviceStatus: STATUS_ACCEPTED,
          communicationSubscriptionVEId:
            delegationData.communicationSubscriptionVEId,
        }),
      )
      await dispatch(
        updateSubsDelegationVE({
          subscriptionDelegationId: delegationData.subscriptionDelegationId,
          isRevoked: false,
        }),
      )
    } else if (REVOKABLE_STATUSES.includes(currentStatus)) {
      await dispatch(
        updateSubsDelegationVE({
          subscriptionDelegationId: delegationData.subscriptionDelegationId,
          isRevoked: false,
        }),
      )
    }
    await dispatch(
      getAllSubsDelegationVE(delegationData.customerSuborganizationCuit),
    )
    handleCloseModal()
  }
  const isSpecialStatus = REVOKABLE_STATUSES.includes(currentStatus)
  return (
    <>
      {isSpecialStatus && isRevoked === true && (
        <Tooltip title={TOOLTIP_MESSAGE} arrow>
          <Button
            variant="contained"
            onClick={() => {
              handleOpenModal()
            }}
            sx={styles}
          >
            Aceptar Delegación
          </Button>
        </Tooltip>
      )}
      {isSpecialStatus && isRevoked === false && (
        <Tooltip title={TOOLTIP_MESSAGE} arrow>
          <span>
            <Button variant="contained" disabled sx={styles}>
              Aceptar Delegación
            </Button>
          </span>
        </Tooltip>
      )}
      {!isSpecialStatus && (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleOpenModal}
          sx={styles}
        >
          Aceptar Delegación
        </Button>
      )}

      <ConfirmModal
        openModal={openModal}
        handleClose={handleCloseModal}
        handleConfirmFunction={handleConfirmAcceptance}
        cuit={delegationData.customerSuborganizationCuit}
      />
    </>
  )
}
